const documentos = {
  ATO_CONSTITUTIVO: { codigo: 'ATO_CONSTITUTIVO', descricao: 'Ato Constitutivo' },
  ESTATUTO: { codigo: 'ESTATUTO', descricao: 'Estatuto' },
  CONTRATO_SOCIAL: { codigo: 'CONTRATO_SOCIAL', descricao: 'Contrato Social' },
  CARTAO_CNPJ: { codigo: 'CARTAO_CNPJ', descricao: 'Cartão CNPJ' },
  CND_FAZENDA_FEDERAL: {
    codigo: 'CND_FAZENDA_FEDERAL',
    descricao: 'Certidão Negativa de Débitos (Fazenda Federal)',
  },
  CND_FAZENDA_ESTADUAL: {
    codigo: 'CND_FAZENDA_ESTADUAL',
    descricao: 'Certidão Negativa de Débitos (Fazenda Estadual)',
  },
  CND_FAZENDA_MUNICIPAL: {
    codigo: 'CND_FAZENDA_MUNICIPAL',
    descricao: 'Certidão Negativa de Débitos (Fazenda Municipal)',
  },
  REGISTRO_AUTOIMPORTADOR_ANP: {
    codigo: 'REGISTRO_AUTOIMPORTADOR_ANP',
    descricao: 'Registro de Autoimportador emitido pela ANP',
  },
  REGISTRO_AUTOPRODUTOR_ANP: {
    codigo: 'REGISTRO_AUTOPRODUTOR_ANP',
    descricao: 'Registro de Autoprodutor emitido pela ANP',
  },
  ATO_COMPROBATORIO_ACESSO_SISTEMA: {
    codigo: 'ATO_COMPROBATORIO_ACESSO_SISTEMA',
    descricao:
      'Ato comprobatório de acesso ao sistema de distribuição em operação do concessionário',
  },
  ACORDO_TECNICO_NOVA_CANALIZACAO: {
    codigo: 'ACORDO_TECNICO_NOVA_CANALIZACAO',
    descricao: 'Acordo técnico ou comercial para nova canalização',
  },
  GARANTIA_VOLUME_GAS_RECEPCAO: {
    codigo: 'GARANTIA_VOLUME_GAS_RECEPCAO',
    descricao: 'Garantias de volume de gás nos pontos de recepção',
  },
  REQUERIMENTO_MERCADO_LIVRE_GAS: {
    codigo: 'REQUERIMENTO_MERCADO_LIVRE_GAS',
    descricao: 'Requerimento para Exercício de Atividade no Mercado Livre de Gás.',
  },
  CND_INSS: { codigo: 'CND_INSS', descricao: 'Certidão Negativa de Débitos (INSS)' },
  CND_FGTS: { codigo: 'CND_FGTS', descricao: 'Certidão Negativa de Débitos (FGTS)' },
  BALANCO_PATRIMONIAL: { codigo: 'BALANCO_PATRIMONIAL', descricao: 'Balanço Patrimonial' },
  DEMONSTRACOES_CONTABEIS: {
    codigo: 'DEMONSTRACOES_CONTABEIS',
    descricao: 'Demonstrações Contábeis',
  },
  CND_FALENCIA: {
    codigo: 'CND_FALENCIA',
    descricao: 'Certidão Negativa de Falência ou Concordata',
  },
  CAPITAL_INTEGRALIZADO: { codigo: 'CAPITAL_INTEGRALIZADO', descricao: 'Capital integralizado' },
  PATRIMONIO_LIQUIDO: { codigo: 'PATRIMONIO_LIQUIDO', descricao: 'Patrimônio Líquido' },
  EQUIPE_TECNICA: { codigo: 'EQUIPE_TECNICA', descricao: 'Equipe Técnica' },
  VOLUME_GAS_CONCESSAO: {
    codigo: 'VOLUME_GAS_CONCESSAO',
    descricao: 'Volume de gás em áreas de concessão',
  },
  TERMO_COMPROMISSO_AUTORIZACAO_COMERCIALIZADOR: {
    codigo: 'TERMO_COMPROMISSO_AUTORIZACAO_COMERCIALIZADOR',
    descricao: 'Termo de Compromisso para Fins de Autorização de Comercializador',
  },
  AUTORIZACAO_COMERCIALIZADOR_ANP: {
    codigo: 'AUTORIZACAO_COMERCIALIZADOR_ANP',
    descricao: 'Autorização de comercializador de gás natural emitida pela ANP',
  },
  CONTRATO_FORNECIMENTO_CONCESSIONARIA: {
    codigo: 'CONTRATO_FORNECIMENTO_CONCESSIONARIA',
    descricao: 'Contrato de fornecimento de gás firmado com a concessionária',
  },
  RESCISAO_CONTRATO_CONCESSIONARIA: {
    codigo: 'RESCISAO_CONTRATO_CONCESSIONARIA',
    descricao: 'Rescisão do contrato com a concessionária',
  },
  REVISAO_CONTRATO_CONCESSIONARIA: {
    codigo: 'REVISAO_CONTRATO_CONCESSIONARIA',
    descricao: 'Revisão do contrato com a concessionária',
  },
  CONTRATO_COMERCIALIZACAO: {
    codigo: 'CONTRATO_COMERCIALIZACAO',
    descricao: 'Contrato de comercialização com o agente comercializador',
  },
  TERMO_COMPROMISSO_AQUISICAO_GAS: {
    codigo: 'TERMO_COMPROMISSO_AQUISICAO_GAS',
    descricao: 'Termo de compromisso de aquisição de gás com o agente comercializador',
  },
  CONTRATO_USO_SISTEMA_DISTRIBUICAO: {
    codigo: 'CONTRATO_USO_SISTEMA_DISTRIBUICAO',
    descricao: 'Contrato de uso do sistema de distribuição de gás',
  },
  TERMO_COMPROMISSO_USO_SISTEMA_DISTRIBUICAO: {
    codigo: 'TERMO_COMPROMISSO_USO_SISTEMA_DISTRIBUICAO',
    descricao: 'Termo de compromisso para uso do sistema de distribuição de gás',
  },
  ACORDO_OPERACIONAL_MERCADO_LIVRE: {
    codigo: 'ACORDO_OPERACIONAL_MERCADO_LIVRE',
    descricao: 'Acordo operacional para o mercado livre',
  },
};

export default documentos;
